import { inject, Injectable } from '@angular/core';
import { AuDialogService } from '@app/core/services/au-dialog.service';
import { IconSnackBarService } from '@app/core/services/icon-snack-bar.service';
import { IChecklistTemplate } from '@app/domain/types';
import { WorkOrdersService } from '@app/pages/cmms/services/work-orders.service';
import { TranslateService } from '@tolgee/ngx';
import { firstValueFrom } from 'rxjs';
import { AuErrorAdapter } from '../au-error-adapter';

@Injectable({
	providedIn: 'root',
})
export class ChecklistService {
	private readonly dialogService = inject(AuDialogService);
	private readonly workOrdersService = inject(WorkOrdersService);
	private readonly notify = inject(IconSnackBarService);
	private readonly translateService = inject(TranslateService);

	async addChecklist(template: IChecklistTemplate): Promise<IChecklistTemplate> {
		const dialogRef = this.dialogService.openAddChecklistItemDialog(
			template?.options || []
		);

		const result: string[] = (await firstValueFrom(dialogRef.afterClosed())) as string[];
		if (!result?.length) return template;
		const newOptions = result.map(option => ({
			question: option,
			answer: null,
			reason: '',
			comment: '',
		}));
		return {
			options: newOptions,
			overallCount: newOptions.length,
		};
	}

	deleteChecklist(checklistId: string) {
		this.workOrdersService.deleteChecklist(checklistId).subscribe({
			next: res => {
				if (!res.success) {
					this.notify.error(
						this.translateService.instant('checklist_status_delete_error')
					);
				}

				this.notify.success(
					this.translateService.instant('checklist_status_delete_success')
				);
			},
			error: error => {
				this.notify.error(AuErrorAdapter.getTextFromGqlError(error));
			},
		});
	}
	updateChecklist(checklistsTemplate: string, id: string) {
		this.workOrdersService.updateChecklist(checklistsTemplate, id).subscribe({
			next: res => {
				if (!res.success) {
					this.notify.error(
						this.translateService.instant('checklist_status_update_error')
					);
				}
			},
			error: error => {
				this.notify.error(AuErrorAdapter.getTextFromGqlError(error));
			},
		});
	}
}
